exports.images = require('./config/images')



//////////////////
// WEBPACK FOOTER
// ../packages/simplesat-config/index.js
// module id = 281
// module chunks = 13